<template>
  <div>
    <div class="inst-title">9.뭉개짐 위험 부분 검사</div>
    <img class="mt-5 w-full" src="../../../assets/images/inst1.jpeg" />
    <pre class="inst-desc">
재료와 재료 사이의 간격이 너무 가까워 서로 붙어 있는 상태로 제조되는 경우입니다. (최소간격: 1mm)
음각의 깊이가 0.4mm 보다 작은 낮음 음각들로 구성된 자잘한 표면 패턴의 경우 주의가 필요한 부분들은 조금 뭉개지거나 흔적만 남을 수 있습니다.</pre
    >

    <div class="inst-subtitle">[생산공정 별 문제]</div>
    <pre
      class="inst-desc"
    >· CNC 가공: 해당 부분의 재료를 제거할 수 없어. '붙어 있는 상태'로 제작.<br>· 사출: 해당 부분을 구현할 수 있는 얇은 금형 캐비티를 제작할 수 없어. '제조가 불가능'.<br>· 3D프린팅: 재료를 녹이거나 경화시키는 과정에서, '재료들끼리 서로 달라붙은 상태'로 제조.</pre>
  </div>
</template>

<script setup></script>
